import React from 'react';
import { Field } from 'formik';

import './checkbox.field.scss';

const CheckboxField = ({ type, children, ...props }) => (
	<label className="checkbox-field">
		<Field type="checkbox" {...props} />
		<span className="checkmark" />

		<span className="checkbox-field-label">{children}</span>
	</label>
);

export default CheckboxField;
